import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

const ScrollToTop = () => {
  const { pathname } = useLocation();

  // biome-ignore lint/correctness/useExhaustiveDependencies: We want to scroll when the route changes
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
};
ScrollToTop.displayName = 'ScrollToTop';

export default ScrollToTop;
